import { FunctionComponent, useMemo } from 'react';
import { Table } from 'components/tables/Table';
import { MontelAccount } from 'domain/account/interfaces';
import { useNavigate } from 'react-router-dom';
import { RequestStatus } from 'types/RequestStatus';
import { accountTableColumns } from 'components/account/accountTableColumns';
import { companyUserColumns } from './companyUserColumns';

const CompanyUserTable: FunctionComponent<{
	accounts: MontelAccount[];
	requestStatus: RequestStatus;
	header?: string;
	withSearch?: boolean;
	withPagination?: boolean;
	companyId: number;
}> = ({
	accounts,
	requestStatus,
	header,
	withSearch,
	withPagination,
	companyId,
}) => {
	const columns = useMemo(
		() => [
			accountTableColumns.fullName(),
			accountTableColumns.email(),
			accountTableColumns.phoneNumber(),
			accountTableColumns.accountCreated(),
			accountTableColumns.activeStatus(),
			companyUserColumns.activeTrials(),
			companyUserColumns.inactiveTrials(),
		],
		[accounts],
	);

	const navigate = useNavigate();

	return (
		<Table<MontelAccount>
			tableId={`company-user-table-${companyId}`}
			header={header}
			columns={columns}
			requestStatus={requestStatus}
			data={accounts}
			withPagination={!!withPagination}
			withSearch={!!withSearch}
			noDataText="No users"
			showRowCount
			onRowClicked={(row: MontelAccount) => {
				navigate(`/accounts/users/${row.id}`);
			}}
		/>
	);
};

export default CompanyUserTable;
